import Clipboard from "vue-clipboard2";
import Vue from "vue";

Vue.use(Clipboard);
